/*
Monotype Foundry Platform API
Version 1.0.0

Definition: BulkImportResponse

Properties:
  error: string
  success: boolean
  tempImportVersion: string
  warning: string
*/

var BulkImportResponse = (function () {
  function validateBulkImportResponse (arg) {
    // Validate error
    if (arg.error && !(typeof arg.error === 'string')) {
      throw new Error('BulkImportResponse.error: Wrong type: Got \'' + (typeof arg.error) + '\', but expected: \'string\'')
    }
    // Validate success
    if (arg.success && !(typeof arg.success === 'boolean')) {
      throw new Error('BulkImportResponse.success: Wrong type: Got \'' + (typeof arg.success) + '\', but expected: \'boolean\'')
    }
    // Validate warning
    if (arg.warning && !(typeof arg.warning === 'string')) {
      throw new Error('BulkImportResponse.warning: Wrong type: Got \'' + (typeof arg.warning) + '\', but expected: \'string\'')
    }
  }
  function buildBulkImportResponse (arg) {
    var BulkImportResponse = arg
    // Complete error
    // Expected Type: string
    BulkImportResponse.error = BulkImportResponse.error || ''
    // Complete success
    // Expected Type: boolean
    BulkImportResponse.success = BulkImportResponse.success || false
    // Complete warning
    // Expected Type: string
    BulkImportResponse.warning = BulkImportResponse.warning || ''
    return BulkImportResponse
  }
  return {
    validate: validateBulkImportResponse,
    build: buildBulkImportResponse
  }
})()

module.exports = BulkImportResponse
